import { render, staticRenderFns } from "./BaseAccordionItem.vue?vue&type=template&id=4847e630&"
import script from "./BaseAccordionItem.vue?vue&type=script&lang=js&"
export * from "./BaseAccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports